




































import VGUserService from '@/api/vguser/VGUserService'
import PageHeader from '@/components/PageHeaderComponent.vue'
import InputFieldComponent from '@/components/input/InputFieldComponent.vue'
import userInfoFunc from '@/shared/functions/userInfoFunc'
import { Vue, Component, Watch } from 'vue-property-decorator'
import ButtonComponent from '@/components/buttons/ButtonComponent.vue'
import InputFieldPhoneNumberGroup from '@/components/input/InputFieldPhoneNumberGroup.vue'
import LogService from '@/api/broadcast/LogService'

@Component({
  components: {
    PageHeader,
    InputFieldComponent,
    ButtonComponent,
    InputFieldPhoneNumberGroup
  }
})

export default class EnterPhoneNumberPage extends Vue {
  public isLoading = false
  public filledNumber = false
  public countryCode = ''
  public phoneNumber = ''
  public invalid = false;
  private inputValidation = false;

  @Watch('phoneNumber') private filledForm () {
    this.filledNumber = (this.phoneNumber !== '' && this.countryCode !== '')
  }

  public soMeType (type: string) {
    switch (type) {
      case 'google':
        return 'Google'
      case 'facebook':
        return 'Facebook'
      case 'apple':
        return 'Apple'
      default:
        return ''
    }
  }

  public validate (inputParam: string) {
    if (this.inputValidation) {
      userInfoFunc.validateInput(inputParam)
    }
    return false
  }

  public async submit () {
    this.inputValidation = true
    await this.numberValidation(this.phoneNumber)
    if (!this.invalid) {
      try {
        // this.$store.state.vaerifyUser = await VGUserService.V2CreateVaerifyUser(this.countryCode + this.phoneNumber)
        this.$store.state.vaerifyUser = await VGUserService.V2CreateVaerifyUser(this.countryCode + this.phoneNumber.replace(/\s/g, ''))
        // this.$store.state.vaerifyUser.PhoneNumber = this.countryCode + this.phoneNumber.replace(/\s/g, '')
        this.$router.push({ name: 'confirm-confirmation-code', params: this.$route.params })
      } catch (e) {
        LogService.LogError(`Failed to create vaerify user with ${this.$route.params.soMeType} in Join Pages with error: ${e}`, {}, '')
      }
    }
  }

  public async numberValidation (phone: string) {
    const result = await userInfoFunc.phoneNumberValidation(phone, this.countryCode)
    // this.showPhoneText = result?.[0]
    this.invalid = result?.[1]
    this.phoneNumber = result?.[2]
  }
}
